import React from 'react'

export const About = () => {
    let myStyle={
        minHeight:"77vh"
    }
    return (
        <div className="container my-3" style={myStyle}>
            <h1>This is About page</h1>
            <h3>In this app we can manage our ToDo task and remove them after completing</h3>
        </div>
    )
}
